import { createQueryStringToggleHook } from "../../../../../stores/useQueryState";

export const tireBrandsParamName = "tire-brands";

export const useTireBrands = createQueryStringToggleHook(
  tireBrandsParamName,
  []
);
